import { store } from "@/lib/states/store";
import type { Org } from "@/lib/states/session/store";
import { trpcVanilla } from "@/lib/trpc/vanilla";

type Destination = "/clients" | "/setup";

const toOrg = (org: {
  id: string;
  name: string;
  slug: string | null;
  createdAt: string;
  setupComplete: boolean;
  weightUnitDefault: string;
  distanceUnitDefault: string;
  primaryColor: string | null;
  logoPath: string | null;
  logoVersion: number;
}): Org => ({
  id: org.id,
  name: org.name,
  slug: org.slug,
  createdAt: org.createdAt,
  setupComplete: org.setupComplete,
  weightUnitDefault: org.weightUnitDefault === "lbs" ? "lbs" : "kg",
  distanceUnitDefault: org.distanceUnitDefault === "mi" ? "mi" : "km",
  primaryColor: org.primaryColor,
  logoPath: org.logoPath,
  logoVersion: org.logoVersion,
});

export async function hydrateOrgFromMembership(
  userId: string,
): Promise<Org | null> {
  const sessionState = store.getState().session;
  if (sessionState.userId === userId && sessionState.org) {
    return sessionState.org;
  }

  try {
    const bootstrap = await trpcVanilla.auth.getSession.query();
    const selected = bootstrap.memberships.find(
      (membership) => membership.orgId === bootstrap.selected?.orgId,
    )?.org;
    if (!selected) {
      return null;
    }

    const org = toOrg(selected);
    sessionState.setActiveOrgId(org.id);
    sessionState.setOrg(org);
    return org;
  } catch (error) {
    console.warn("[postAuthDestination] membership lookup failed", error);
    return null;
  }
}

export async function resolvePostAuthDestination(
  userId: string,
): Promise<Destination> {
  const sessionState = store.getState().session;
  const existingOrg =
    (sessionState.userId === userId ? sessionState.org : undefined) ??
    (await hydrateOrgFromMembership(userId));
  if (!existingOrg) return "/setup";
  return existingOrg.setupComplete ? "/clients" : "/setup";
}
